import React from 'react'

const Failure = () => {
  return (
    <div>Failure</div>
  )
}

export default Failure
